import { angularJsApp } from "../app";
import { AppComponentsEnum } from "../app.model";
import { CentresPreinscripcioService } from "../services/centres-preinscripcio.service";
import { ConfiguracioService } from "../services/configuracio.service";

class Component {
  resolve: { centresAdscrits: any[], centre: any, centresAdscritsPare: any[], selectedTab: number };
  centre: any;
  centresAdscrits: any[];
  centresAdscritsPare: any[];
  selectedTab: number;
  modalInstance: ng.ui.bootstrap.IModalInstanceService;

  constructor(
    private Configuracio: ConfiguracioService,
    private CentresPreinscripcio: CentresPreinscripcioService,
    private $uibModal: ng.ui.bootstrap.IModalService,
  ) { 
  }

  $onInit() {
    this.centre = this.resolve.centre;
    this.centresAdscrits = this.resolve.centresAdscrits;
    this.centresAdscritsPare = this.resolve.centresAdscritsPare;
    this.selectedTab = this.resolve.selectedTab;
  }

  // Close the modal
  ok(): void {
    this.modalInstance.dismiss();
  }

  // Show the modal for SFP offer
  showOfertaCentreSFP(centre: any): void {
    this.modalInstance.dismiss({ status: 'OPEN_SFP', data: centre });
  }

  // Show the centres in the map
  showCentresAdscritsInMap(): void {
    const objFilterBbox = this.setFilterAndBBox();
    const centresAdscrits = [...(this.centresAdscritsPare || []), ...(this.centresAdscrits || [])];

    if (this.selectedTab === 0) {
      Promise.all(
        centresAdscrits.map((centre) => this.CentresPreinscripcio.getGeoserverCentres(centre))
      ).then((data) => {
        this.modalInstance.close({
          filter: objFilterBbox.filter,
          bboxObj: objFilterBbox.bboxObj,
          dataGeoserver: data,
        });
      });
    } else if (this.selectedTab === 1) {
      this.modalInstance.close({ filter: objFilterBbox.filter, bboxObj: objFilterBbox.bboxObj });
    }
  }

  // Build the filter and bounding box for the map
  private setFilterAndBBox(): { filter: string; bboxObj: { bboxGeo: number[] } } {
    const totalAdscrits = [];
    const coordsX: number[] = [];
    const coordsY: number[] = [];
    let filter = '(1=1)';
    const offset = 100;

    if (this.centresAdscrits.length) {
      totalAdscrits.push(...this.centresAdscrits);
    }

    if (this.centresAdscritsPare.length) {
      totalAdscrits.push(...this.centresAdscritsPare);
    }

    if (totalAdscrits.length) {
      filter += ' AND (';
      totalAdscrits.forEach((centre, index) => {
        if (this.checkCoords(centre)) {
          if (index > 0) filter += ' OR ';
          filter += `CODI_CENTRE= '${centre.codiCentre}'`;
          coordsX.push(Number(centre.coordX.replace(',', '.')));
          coordsY.push(Number(centre.coordY.replace(',', '.')));
        }
      });
      filter += ')';

      const minX = Math.min(...coordsX) - offset;
      const minY = Math.min(...coordsY) - offset;
      const maxX = Math.max(...coordsX) + offset;
      const maxY = Math.max(...coordsY) + offset;

      return { filter, bboxObj: { bboxGeo: [minX, minY, maxX, maxY] } };
    }

    return { filter, bboxObj: { bboxGeo: [] } };
  }

  // Center the map on a specific centre
  centreAdscrit(elem: any): void {
    if (this.checkCoords(elem)) {
      const offset = 100;
      const coordX = Number(elem.coordX.replace(',', '.'));
      const coordY = Number(elem.coordY.replace(',', '.'));

      const newFilter = `(1=1) AND (CODI_CENTRE= '${elem.codiCentre}')`;
      const bboxObj = {
        bboxCentre: [coordX - offset, coordY - offset, coordX + offset, coordY + offset],
        bboxGeo: [],
      };

      if (this.selectedTab === 0) {
        this.CentresPreinscripcio.getGeoserverCentres(elem).then((data) => {
          this.modalInstance.close({
            filter: newFilter,
            bboxObj: bboxObj,
            dataGeoserver: [data],
          });
        });
      } else if (this.selectedTab === 1) {
        this.modalInstance.close({ filter: newFilter, bboxObj: bboxObj });
      }
    }
  }

  // Check if coordinates are valid
  checkCoords(elem: any): boolean {
    return (
      elem.coordX !== null &&
      elem.coordY !== null &&
      elem.coordX.trim() !== '' &&
      elem.coordY.trim() !== ''
    );
  }

  // Open an external window
  openWindow(centre): void {
    this.$uibModal.open(
      {
        animation: true,
        component: AppComponentsEnum.FITXA_CENTRE,
        size: 'xl',
        resolve: { centre },
      }
    );
  }
}

const component: ng.IComponentOptions = {
  bindings: {
    modalInstance: "<",
    resolve: "<",
  },
  templateUrl: './components/modal-centres-adscrits.component.html',
  controller: Component,
};

angularJsApp.component(AppComponentsEnum.CENTRES_AD, component);

